"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styles_styled_1 = require("./styles.styled");
const react_1 = require("react");
const styled_components_1 = require("styled-components");
const helpers_1 = require("../../helpers");
const FakedCheckbox_1 = __importDefault(require("../../componentReusable/FakedCheckbox"));
const IconUpload_1 = __importDefault(require("../../assets/icons/IconUpload"));
const Field_1 = __importDefault(require("../../componentReusable/Field"));
const member_1 = require("../../dataLayer/apisWithoutCache/membersApi/member");
const AppContextProvider_1 = require("../../contexts/AppContextProvider");
const cookiesMember_1 = require("../../dataLayer/cookiesAndLocalStorage/cookiesMember");
const constants_1 = require("../../constants");
const localStorageUtility_1 = __importDefault(require("../../hooks/localStorageUtility"));
const useTrackPageView_1 = __importDefault(require("../../GTMs/useTrackPageView"));
const slrActions_1 = require("../../GTMs/actions/slrActions");
const loggingTypes_1 = require("../../libs/logging/types/loggingTypes");
const useScreenLoadLogging_1 = __importDefault(require("../../hooks/useScreenLoadLogging"));
const slrActions_2 = require("../../libs/loggingAPIs/actions/slrActions");
const helpers_2 = require("../../libs/loggingAPIs/helpers");
const loggingActions_1 = require("../../libs/logging/helpers/loggingActions");
const auth_1 = __importDefault(require("../../auth"));
const memberReducer = (state, action) => {
    return { Member: Object.assign(Object.assign({}, state === null || state === void 0 ? void 0 : state.Member), action === null || action === void 0 ? void 0 : action.Member) };
};
const { setItem: setLocalStorage } = (0, localStorageUtility_1.default)();
const RegistrationScreen = ({ ssoConfiguration }) => {
    var _a, _b, _c;
    const { flowState, dispatch } = (0, AppContextProvider_1.useSsoContext)();
    const memberInitState = {
        Member: {
            M_fisrt_name: "",
            newPassword: "",
            M_email: "",
            phone_number: flowState.phone,
        },
    };
    const [member, dispatchMember] = (0, react_1.useReducer)(memberReducer, memberInitState);
    const [error, setError] = (0, react_1.useState)({});
    const { translations, isDesktop, isMobile } = (0, styled_components_1.useTheme)();
    const [selectedImage, setSelectedImage] = (0, react_1.useState)(null);
    const [imagePreview, setImagePreview] = (0, react_1.useState)("");
    const [checked, setChecked] = (0, react_1.useState)(true);
    (0, useTrackPageView_1.default)("slrRegistrationScreen", true, true);
    (0, useScreenLoadLogging_1.default)(loggingTypes_1.EnumLoggingScreenNames.AUTHENTICATION_REGISTER_FORM);
    const handleImageChange = (event) => __awaiter(void 0, void 0, void 0, function* () {
        const file = event.target.files[0];
        if (file && file.type.startsWith('image/')) {
            setSelectedImage(file);
            setError({});
        }
        else {
            setError({ image: 'Please select a valid image file.' });
            setSelectedImage(null);
        }
    });
    (0, react_1.useEffect)(() => {
        if (selectedImage) {
            handleUpload().then();
        }
    }, [selectedImage]);
    (0, react_1.useEffect)(() => {
        var _a;
        const auth = auth_1.default.getInstance();
        if (!imagePreview && ((_a = auth === null || auth === void 0 ? void 0 : auth.identity) === null || _a === void 0 ? void 0 : _a.profile_picture)) {
            setImagePreview(auth.identity.profile_picture);
        }
    }, []);
    const handleUpload = () => __awaiter(void 0, void 0, void 0, function* () {
        if (selectedImage) {
            const reader = new FileReader();
            reader.onload = (e) => __awaiter(void 0, void 0, void 0, function* () {
                const imageBuffer = e.target.result;
                const formData = new FormData();
                formData.append("Member[avatarFile]", new Blob([imageBuffer]));
                (0, member_1.changeMemberAvatar)(formData)
                    .then((res) => setImagePreview(res.profile_picture))
                    .catch((e) => console.log(e));
            });
            reader.readAsArrayBuffer(selectedImage);
        }
    });
    const onSubmitRegister = () => __awaiter(void 0, void 0, void 0, function* () {
        (0, loggingActions_1.authenticateRegisterSubmitAction)();
        yield (0, member_1.handleUpdateMemberInfo)(member)
            .then((member) => {
            var _a, _b, _c;
            (0, loggingActions_1.authenticateRegisterSuccessAction)(member.id);
            (0, cookiesMember_1.setMemberCookies)(member);
            //This line for incomplete registration;
            auth_1.default.getInstance().identity = member;
            dispatch({
                screenType: constants_1.ScreenConstants.LOGIN_SUCCESS,
                successScreen: {
                    title: ((_a = member === null || member === void 0 ? void 0 : member.success) === null || _a === void 0 ? void 0 : _a.title) || translations.registrationCompleted,
                    description: ((_b = member === null || member === void 0 ? void 0 : member.success) === null || _b === void 0 ? void 0 : _b.description) ||
                        ((_c = translations.nowVerified) === null || _c === void 0 ? void 0 : _c.replace("[MOBILE_NUM]", flowState === null || flowState === void 0 ? void 0 : flowState.phone)),
                    withAddPost: true,
                },
                memberData: member
            });
            if (checked) {
                setLocalStorage(constants_1.LocalStorageConstants.PHONE_NUMBER, flowState.phone);
            }
            else {
                setLocalStorage(constants_1.LocalStorageConstants.PHONE_NUMBER, "");
            }
            (0, slrActions_1.gtmWABtn_SLRRegistrationScreen)();
            (0, slrActions_2.loggingAttemptUserClick)((0, helpers_2.createSlrLoggingBody)(member, "AttemptWhatsAppRegistrationVerification", ssoConfiguration));
        })
            .catch((error) => {
            console.log(error, "error");
            if (error && (error === null || error === void 0 ? void 0 : error.toValidationErrorMsg())) {
                setError(error === null || error === void 0 ? void 0 : error.toValidationErrorMsg());
            }
        });
    });
    (0, react_1.useEffect)(() => {
        var _a, _b;
        if (((_a = member.Member) === null || _a === void 0 ? void 0 : _a.M_fisrt_name.length) >= 1 && ((_b = member.Member) === null || _b === void 0 ? void 0 : _b.newPassword.length) >= 1) {
            function onKeyup(event) {
                if (event.key === "Enter")
                    onSubmitRegister();
                else if (event.code === "Enter")
                    onSubmitRegister();
            }
            const keyEventListener = window;
            if (typeof window !== "undefined") {
                keyEventListener.addEventListener("keydown", onKeyup, false);
                return () => keyEventListener.removeEventListener("keydown", onKeyup, false);
            }
        }
    }, [member]);
    return ((0, jsx_runtime_1.jsxs)(styles_styled_1.RegistrationScreenCont, Object.assign({ id: "registrationScreen" }, (0, helpers_1.classNames)(isDesktop && "width-460 border radius-8 overflowHidden"), { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({}, (0, helpers_1.classNames)("p-16 whiteBg", isMobile && "pt-0"), { children: [(0, jsx_runtime_1.jsx)("strong", Object.assign({ className: "font-22" }, { children: translations.completeRegistration })), (0, jsx_runtime_1.jsx)("p", Object.assign({ className: "font-14 mt-8" }, { children: translations.completeRegistrationP }))] })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "grayBg p-16 font-17" }, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "whiteBg p-16 mb-16 radius-8 fullShadow" }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: "center mb-16" }, { children: (0, jsx_runtime_1.jsxs)("label", Object.assign({ className: "font-13 inline darkGray" }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: "flex justifyContent alignItems center m-auto mb-16 fullRadius pointer" }, { children: Boolean(imagePreview) ? ((0, jsx_runtime_1.jsx)("img", { alt: imagePreview, src: imagePreview, width: "100%", height: "100%", className: "fullRadius" })) : ((0, jsx_runtime_1.jsx)(IconUpload_1.default, {})) })), translations.uploadPhoto, (0, jsx_runtime_1.jsx)("input", { type: "file", accept: "image/*", className: "hide", onChange: handleImageChange })] })) })), (0, jsx_runtime_1.jsx)(Field_1.default, { type: "text", label: translations.fullName, onChangeCb: (value) => dispatchMember({ Member: { M_fisrt_name: value } }), error: (error === null || error === void 0 ? void 0 : error["M_fisrt_name"]) || "", value: member.Member.M_fisrt_name, onClearCb: () => dispatchMember({ Member: { M_fisrt_name: "" } }), autoFocus: true }), (0, jsx_runtime_1.jsx)(Field_1.default, { type: "password", label: translations.password, onChangeCb: (value) => dispatchMember({ Member: { newPassword: value } }), value: member.Member.newPassword, error: (error === null || error === void 0 ? void 0 : error["newPassword"]) || "", onClearCb: () => dispatchMember({ Member: { newPassword: "" } }) }), (0, jsx_runtime_1.jsx)(Field_1.default, { type: "email", label: translations.email, onChangeCb: (value) => dispatchMember({ Member: { M_email: value } }), value: member.Member.M_email, error: (error === null || error === void 0 ? void 0 : error["M_email"]) || "", onClearCb: () => dispatchMember({ Member: { M_email: "" } }) })] })), (0, jsx_runtime_1.jsx)(FakedCheckbox_1.default, Object.assign({ setChecked: setChecked, checked: checked }, { children: translations.rememberMe })), (0, jsx_runtime_1.jsx)("button", Object.assign({}, (0, helpers_1.classNames)("blueBtn p-20 mt-16 font-17", (((_b = (_a = member === null || member === void 0 ? void 0 : member.Member) === null || _a === void 0 ? void 0 : _a.M_fisrt_name) === null || _b === void 0 ? void 0 : _b.length) < 1 ||
                        ((_c = member.Member) === null || _c === void 0 ? void 0 : _c.newPassword) < 1) &&
                        "disabled"), { onClick: () => {
                            onSubmitRegister().then();
                            (0, slrActions_1.gtmWABtn_SLRRegistrationScreen)();
                        } }, { children: translations.continue }))] }))] })));
};
exports.default = RegistrationScreen;
